const baseUrl = 'https://www.lianganfenghui.com/api/lafh-service';
export default baseUrl;